import {
  createRootRouteWithContext,
  Outlet,
  useNavigate,
  useLocation,
  useRouterState,
} from "@tanstack/react-router";
import React from "react";
// eslint-disable-next-line
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { IAuthContext, useAuth } from "../contexts/AuthContext";
import { Navbar } from "@/components/layout/Navbar";

export const Route = createRootRouteWithContext<{ auth: IAuthContext }>()({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
  }),
  component: RootComponent, // eslint-disable-line  @typescript-eslint/no-use-before-define
});

function RootComponent() {
  const { isLoggedIn, loading } = useAuth();
  const navigate = useNavigate({ from: Route.fullPath });
  const location = useLocation();
  const routerState = useRouterState();
  const search = Route.useSearch();

  React.useEffect(() => {
    if (loading) return;

    const shouldRedirectToHome = isLoggedIn && location.pathname === "/login";
    const shouldRedirectToLogin =
      !isLoggedIn &&
      location.pathname !== "/login" &&
      location.pathname !== "/login-link-modal" &&
      location.pathname !== "/login-link";

    if (shouldRedirectToHome) {
      const to = search.redirect || "/demo";
      navigate({ to, replace: true });
    }
    if (shouldRedirectToLogin) {
      navigate({
        to: "/login",
        replace: true,
        search: {
          redirect: routerState.location.href,
        },
      });
    }
  }, [
    isLoggedIn,
    loading,
    location.pathname,
    navigate,
    routerState.location.href,
    routerState.location.pathname,
    search.redirect,
  ]);

  const isFullWidthRoute =
    location.pathname === "/home" ||
    location.pathname === "/prototypes/comps" ||
    location.pathname === "/prototypes/comps/concepts";
  const isBareRoute =
    location.pathname === "/demo" ||
    location.pathname === "/prototypes/innovation-days-demo";

  if (isBareRoute) return <Outlet />;

  return (
    <div className="bg-secondary-950 min-h-screen">
      <Navbar />
      <div
        className={
          isFullWidthRoute
            ? "max-w-[100vw] mx-auto px-[1.5rem]"
            : "max-w-[100rem] mx-auto px-[1.5rem]"
        }
      >
        <Outlet />
      </div>
      {import.meta.env.VITE_ENVIRONMENT === "local" && (
        <TanStackRouterDevtools />
      )}
    </div>
  );
}
